import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const snmpUserTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'SNMP User',
  key: 'snmpUser',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['USERNAME', 'AUTHPASSWD', 'PRIVPASSWD'],
          ['SECURITYLVL', 'HASHTYPE', 'PRIVPROTO'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      USERNAME: {
        label: 'Username',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 32,
            },
          ],
        },
      },
      AUTHPASSWD: {
        label: 'Authenticaton Password',
        type: 'password',
        validation: {
          validators: [
            {
              type: 'length',
              length: 20
            },
            {
              type: 'regexp',
              regexp: [
                'letters',
                'digits',
                'spaces',
                '-_.~!@#$%^*+?'
              ],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.'
            }
          ]
        }
      },
      PRIVPASSWD: {
        label: 'Privacy Password',
        type: 'password',
        validation: {
          validators: [
            {
              type: 'length',
              length: 20
            },
            {
              type: 'regexp',
              regexp: [
                'letters',
                'digits',
                'spaces',
                '-_.~!@#$%^*+?'
              ],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.'
            }
          ]
        }
      },
      SECURITYLVL: {
        label: 'Security Level',
        type: 'select',
        initial: 'NOAUTHNOPRIV',
        affectedFieldsOnChange: [
          'authpasswd',
          'privpasswd'
        ],
        options: [
          {
            label: 'NOAUTHNOPRIV',
            value: 'NOAUTHNOPRIV'
          },
          {
            label: 'AUTHNOPRIV',
            value: 'AUTHNOPRIV'
          },
          {
            label: 'AUTHPRIV',
            value: 'AUTHPRIV'
          }
        ],
        optionsTranslatable: true
      },
      HASHTYPE: {
        label: 'Hash Type',
        type: 'select',
        initial: 'MD5',
        options: [
          {
            label: 'MD5',
            value: 'MD5'
          },
          {
            label: 'SHA',
            value: 'SHA'
          }
        ]
      },
      PRIVPROTO: {
        label: 'Privacy Protocol',
        type: 'select',
        initial: 'DES',
        options: [
          {
            label: 'DES',
            value: 'DES'
          },
          {
            label: 'AES',
            value: 'AES'
          }
        ]
      }
    },
  },
};
